import { request } from './client';
import type { ModuleListResponse, ModuleRequestResult } from '@kassa/shared';

export const modulesApi = {
  modules: () => request<ModuleListResponse>('GET', '/api/modules'),
  requestModule: (code: string) =>
    request<ModuleRequestResult>('POST', `/api/modules/${encodeURIComponent(code)}/request`),
};
